import React, { Component } from 'react'
import { Link } from "react-router-dom";
// import { withRouter } from '../../utils/with-router';
import './Header.css'

const mapping = {
  '/': 0,
  '/about': 1,
  '/newsblogs': 2,
  '/members': 3,
  '/sponsorship': 4,
  '/contact': 5
}

class Header extends Component {

  menuRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
      selectedItem: 0
    };
    this.handleMenuClick = this.handleMenuClick.bind(this);
  }

  componentDidMount() {
    const location = window.location.pathname;
    const locationIndex = mapping[location];
    if (locationIndex !== undefined) {
      this.setState({ selectedItem: locationIndex });
    }
  }

  handleMenuClick() {
    this.setState(prevState => ({
      isMenuOpen: !prevState.isMenuOpen
    }));

    const node = this.menuRef.current;
    node.style.display = this.state.isMenuOpen ? 'none' : 'block';
  }
  
  render() {
   
    return (
      <div className='header_container'>
       <div className='header_background'>
          <div className='navi'>
            <div className='navi_logo'>
              <Link to={'/'}  className='logo' onClick={() => { window.scroll(0, 0);  }}>
                <img  alt="logo" />
              </Link>
            </div>

              <div className='menu' ref={this.menuRef}>
                <Link to={"/"}  className='nav-link' onClick={() => { window.scroll(0, 0); this.setState({ selectedItem: 0 }); }}>
                  <h4 className={`menu_option${this.state.selectedItem === 0? '-selected': ''}`}>Home</h4>
                </Link>
                <Link to={"/about"} className='nav-link'onClick={() => { window.scroll(0, 0); this.setState({ selectedItem: 1 }); }}>
                  <h4 className={`menu_option${this.state.selectedItem === 1? '-selected': ''}`}>About</h4>
                </Link>
                <Link to={"/newsblogs"} className="nav-link"onClick={() => { window.scroll(0, 0); this.setState({ selectedItem: 2 }); }}>
                  <h4 className={`menu_option${this.state.selectedItem === 2? '-selected': ''}`}>Press Release</h4>
                </Link>
                <Link to={"/members"} className='nav-link'onClick={() => { window.scroll(0, 0); this.setState({ selectedItem: 3 }); }}>
                  <h4 className={`menu_option${this.state.selectedItem === 3? '-selected': ''}`}>Our Members</h4>
                </Link>
                <Link to={"/sponsorship"} className="nav-link"onClick={() => { window.scroll(0, 0); this.setState({ selectedItem: 4 }); }}>
                  <h4 className={`menu_option${this.state.selectedItem === 4? '-selected': ''}`}>Sponsorship</h4>
                </Link>
                <Link to={"/contact"} className="nav-link"onClick={() => { window.scroll(0, 0); this.setState({ selectedItem: 5 }); }}>
                  <h4 className={`menu_option${this.state.selectedItem === 5? '-selected': ''}`}>Contact Us</h4>
                </Link>
              </div>

              {/* <button className='login_button'>Login</button>
              <button className='regisger_button'>Register</button> */}
          </div>
       </div>
      </div>
    )
  }
}

export default Header
